export default __webpack_public_path__ + "5ea3c0478c9db46107354c1c356da295.png";